import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const TrendingIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.924 4.617a.997.997 0 0 0-.215-.322l-.004-.004A.997.997 0 0 0 15.003 4H11a1 1 0 1 0 0 2h1.586L9 9.586 5.707 6.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 1 0 1.414 1.414L5 8.414l3.293 3.293a1 1 0 0 0 1.414 0L14 7.414V9a1 1 0 1 0 2 0V4.997a.996.996 0 0 0-.076-.38Z", fill: "currentColor" })));
});
TrendingIcon.displayName = 'TrendingIcon';
export default TrendingIcon;
